<template>
  <q-card-actions class="modal-footer-actions bg-white q-pa-md text-primary" align="right">
    <q-btn
      v-close-popup
      label="Cancel"
      color="secondary"
      outline
      class="light-bordered light-radius"
      padding="0.25rem 1rem"
      no-caps
      :disable="isLoading || isSuggesting"
      @click="emit('cancel')"
    />

    <q-btn
      v-if="currentStep === CREATE_MODAL_STEPS.RESULTS"
      label="Search again"
      color="secondary"
      outline
      no-caps
      padding="0.25rem 1rem"
      class="light-bordered light-radius q-ml-sm"
      :disable="isLoading"
      @click="emit('search-again')"
    />

    <q-space />

    <div v-if="currentStep === CREATE_MODAL_STEPS.INPUT" class="step-actions">
      <q-btn
        v-if="type === 'company'"
        class="light-bordered light-radius text-primary"
        label="Search with AI"
        icon="auto_awesome"
        color="cta"
        padding="0.25rem 1.25rem"
        unelevated
        no-caps
        :loading="isSuggesting"
        :disable="!inputValue || isLoading"
        @click="emit('search')"
      />
      <q-btn
        v-if="type === 'product'"
        class="light-bordered light-radius text-primary"
        label="Continue"
        color="cta"
        padding="0.25rem 1.25rem"
        unelevated
        no-caps
        :loading="isLoading"
        :disable="!inputValue || isSuggesting"
        @click="emit('submit', { useSuggestion: false })"
      />
    </div>

    <q-btn
      v-if="currentStep === CREATE_MODAL_STEPS.RESULTS"
      class="light-bordered light-radius text-primary"
      :label="primaryActionLabel"
      color="cta"
      padding="0.25rem 1.25rem"
      unelevated
      no-caps
      :loading="isLoading"
      :disable="primaryActionDisabled || isLoading"
      @click="emit('commit')"
    />
  </q-card-actions>
</template>

<script setup>
import { CREATE_MODAL_STEPS } from 'src/services/consts/company.const'

defineProps({
  type: {
    type: String,
    required: true,
    validator: (value) => ['company', 'product'].includes(value),
  },
  inputValue: {
    type: String,
    required: true,
  },
  currentStep: {
    type: String,
    required: true,
    validator: (value) => Object.values(CREATE_MODAL_STEPS).includes(value),
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
  isSuggesting: {
    type: Boolean,
    default: false,
  },
  primaryActionLabel: {
    type: String,
    default: '',
  },
  primaryActionDisabled: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['cancel', 'search', 'submit', 'commit', 'search-again'])
</script>

<style lang="scss">
.modal-footer-actions {
  .step-actions {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .q-btn {
    .q-icon {
      font-size: 1.1rem;
      margin-inline-end: 0.25rem;
    }
  }
}
</style>
